module.exports = __webpack_public_path__ + "img/statistics.205254d0.svg";